<template>
  <div
    :class="kls"
    data-component-name="PageHeader"
    data-event-name="view"
    data-event-content="页头展示"
  >
    <div v-if="$slots.breadcrumb" :class="ns.e('breadcrumb')">
      <slot name="breadcrumb" />
    </div>
    <div :class="ns.e('header')">
      <div :class="ns.e('left')">
        <div
          :class="ns.e('back')"
          role="button"
          tabindex="0"
          data-component-name="Page Header"
          data-event-name="back"
          data-event-content="点击返回按钮"
          @click="handleClick"
        >
          <div
            v-if="icon || $slots.icon"
            :aria-label="title || t('el.pageHeader.title')"
            :class="ns.e('icon')"
          >
            <slot name="icon">
              <jd-icon v-if="icon">
                <component :is="icon" />
              </jd-icon>
            </slot>
          </div>
          <div
            v-else
            :aria-label="title || t('el.pageHeader.title')"
            :class="ns.e('icon')"
          >
            <jd-button
              class="back-icon-btn"
              size="small"
              :icon="AngleLeft"
              plain
            />
          </div>
          <div
            v-if="!hideTitle"
            :class="ns.e('title')"
            data-component-name="Page Header"
            data-event-name="click"
            data-event-content="点击标题"
          >
            <slot name="title">{{ title || t('el.pageHeader.title') }}</slot>
          </div>
        </div>
        <jd-divider v-if="!hideTitle" direction="vertical" />
        <div :class="ns.e('content')">
          <slot name="content">{{ content }}</slot>
        </div>
      </div>

      <div v-if="$slots.extra" :class="ns.e('extra')">
        <slot name="extra" />
      </div>
    </div>

    <div v-if="$slots.default" :class="ns.e('main')">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { AngleLeft } from '@jd/jdesign-icons-vue'
import { JdIcon } from '@jdesign-vue/components/icon'
import { JdDivider } from '@jdesign-vue/components/divider'

import { useLocale, useNamespace } from '@jdesign-vue/hooks'
import { pageHeaderEmits, pageHeaderProps } from './page-header'

defineOptions({
  name: 'JdPageHeader',
})

defineProps(pageHeaderProps)
const emit = defineEmits(pageHeaderEmits)
const slots = useSlots()

const { t } = useLocale()
const ns = useNamespace('page-header')
const kls = computed(() => {
  return [
    ns.b(),
    {
      [ns.m('has-breadcrumb')]: !!slots.breadcrumb,
      [ns.m('has-extra')]: !!slots.extra,
      [ns.is('contentful')]: !!slots.default,
    },
  ]
})

function handleClick() {
  emit('back')
}
</script>
